import { ErrorCode } from "../types/ErrorCode";

export const errorMessages: Record<ErrorCode, string> = {
    [ErrorCode.Unknown]: "Unknown or unhandled error",

    // BinanceOptionsSecuredDataService = 100
    [ErrorCode.BinanceUnknown]: "Unknown Binance related error",
    [ErrorCode.BinanceUnauthorized]: "Not authorized to access the Binance API",
    [ErrorCode.BinanceInvalidPriceMultiplicity]: "Price must be a multiple of 5",
    [ErrorCode.BinancePriceLessThanOrEqualToZero]: "Price must be a positive",
    [ErrorCode.BinanceInvalidSizeMultiplicity]: "Size must be a multiple of 0.01",
    [ErrorCode.BinanceApiKeyEmpty]: "Binance API key is empty",
    [ErrorCode.BinanceTimestampLessThanOrEqualToZero]: "Request timestamp must be greater than zero",
    [ErrorCode.BinanceReceiveWindowLessThanOrEqualToZero]: "Request receive window parameter must be greater than zero",
    [ErrorCode.BinanceSignatureEmpty]: "Request signature is empty",
    [ErrorCode.BinanceSymbolEmpty]: "Symbol is empty",
    [ErrorCode.BinanceOrderIdLessThanOrEqualToZero]: "Binance order ID must be greater than zero",
    [ErrorCode.BinanceInternalOrderIdIsNull]: "Binance order ID cannot be null",
    [ErrorCode.BinanceInternalOrderIdLessThanOrEqualToZero]: "Order ID must be greater than zero",
    [ErrorCode.BinanceSizeEqualZero]: "Size cannot be equal zero",
    [ErrorCode.BinanceInvalidOrderType]: "Requested order type is not supported",
    [ErrorCode.BinanceInvalidOrderSide]: "Order side must be either BUY or SELL",
    [ErrorCode.BinanceApiKeyIsNull]: "The Binance API key is not configured in the application settings",
    [ErrorCode.BinanceSecretKeyIsNull]: "The Binance secret key is not configured in the application settings",

    // PortfolioInfo = 200
    [ErrorCode.PortfolioItemIdLessThanOrEqualToZero]: "Portfolio item ID must be greater than zero",
    [ErrorCode.AutoOrderConfigurationRequired]: "Auto order configuration is required",
    [ErrorCode.AutoOrderConfigurationPortfolioItemIdMismatch]: "Portfolio item ID does not match auto order configuration",
    [ErrorCode.AutoOrderStrategyUnsupported]: "Auto order strategy is not supported",
    [ErrorCode.AutoOrderTargetPriceLessThanOrEqualToZero]: "Target price must be greater than zero",
    [ErrorCode.AutoOrderMaxImpliedVolatilityLevelLessThanOrEqualToZero]: "Max implied volatility level must be greater than zero",
    [ErrorCode.AutoOrderMaxPriceDeltaLessThanOrEqualToZero]: "Max price delta must be greater than zero",
};
